import React, { Component, Suspense } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { connect } from "react-redux";
import { auth } from "./actions";

import Preloader from "./components/generics/preloader";

import FormSetting from "./components/Setting/FormSetting";
import TextSetting from "./components/Setting/TextSetting";
import ImageSetting from "./components/Setting/ImageSetting";
import DeviceSetting from "./components/Setting/DeviceSetting";
import DashboardSetting from "./components/Setting/DashboardSetting";
import ForgotPassword from "./components/Login/ForgotPassword";
import ChangePassword from "./components/Login/ChangePassword";


const NotFound = React.lazy(() => import("./components/generics/notfound"));
const Index = React.lazy(() => import("./components"));
const ProxyLogin = React.lazy(() => import("./components/Login"));
const Login = React.lazy(() => import("./components/Login/Login"));
const Register = React.lazy(() => import("./components/Login/Register"));
const Dashboard = React.lazy(() => import("./components/Dashboard"));
const Employee = React.lazy(() => import("./components/Employee"));
const FeedbackForms = React.lazy(() => import("./components/FeedbackForms/index"));
const FeedbackFormsDetails = React.lazy(() =>
  import("./components/FeedbackForms/FeedbackFormDetail/")
);
const Response = React.lazy(() => import("./components/Response"));
const Templates = React.lazy(() => import("./components/Templates"));
const TemplateDetail = React.lazy(() =>
  import("./components/Templates/TemplateDetail")
);
const Customers = React.lazy(() => import("./components/Customers"));
const CustomerDetails = React.lazy(() =>
  import("./components/Customers/CustomerDetails")
);
const UploadCustomers = React.lazy(() =>
  import("./components/Customers/Upload")
);

const BalanceHistory = React.lazy(() => import("./components/BalanceHistory"));

const CampaignReport = React.lazy(() =>
  import("./components/Reports/Campaign")
);
const DetailedReport = React.lazy(() =>
  import("./components/Reports/Campaign/DetailedReport")
);

const Feedbacks = React.lazy(() => import("./components/Feedbacks"));
const FeedbackDetails = React.lazy(() =>
  import("./components/Feedbacks/FeedbackDetails")
);

const TicketManagement = React.lazy(() => import("./components/TicketManagement"));
const TicketDetails = React.lazy(() =>
  import("./components/Feedbacks/FeedbackDetails")
);





const Preview = React.lazy(() => import("./components/Preview"));

// Report Routes

const ReportPage = React.lazy(() => import("./components/ReportPage"));
const GenerateReport = React.lazy(() =>
  import("./components/ReportPage/GenerateReport")
);

const DetailedGenerateReport = React.lazy(() =>
  import("./components/ReportPage/GenerateReport/DetailedReport/")
);


// Settings Routes

const SettingPage = React.lazy(() => import("./components/Setting"));

// Subscription Routes

const SubscriptionPage = React.lazy(() => import("./components/Subscription"));



class Routes extends Component {
  componentDidMount() {
    if (!this.props.auth.isAuthenticated) {
      this.props.loadUser();
    }
  }

  PrivateRoute = ({ component: ChildComponent, ...rest }) => {
    return (
      <Route
        {...rest}
        render={(props) => {
          if (this.props.auth.isLoading) {
            return <em>Loading...</em>;
          } else if (!this.props.auth.isAuthenticated) {
            return <Redirect to="/login/" />;
          } else {
            return <ChildComponent {...props} />;
          }
        }}
      />
    );
  };

  render() {
    let PrivateRoute = this.PrivateRoute;

    return (
      <Router>
        <Suspense fallback={<Preloader />}>
          <Switch>
            <Route path="/" component={Login} exact />
            <Route path="/redirect/login/" component={ProxyLogin} exact />
            <Route path="/login/" component={Login} exact />
            <Route path="/forgot-password/" component={ForgotPassword} exact />
            <Route
              path="/password-reset/:token"
              component={ChangePassword}
              exact
            />
            <Route path="/register/" component={Register} exact />

            <Route path="/response/:slug/" component={Response} exact />
            <Route path="/response/:slug/:fid" component={Response} exact />

            <Route
              path="/feedback-form-templates/"
              component={Templates}
              exact
            />
            <Route
              path="/feedback-form-templates/c/:slug-feedback-form-templates/"
              component={Templates}
              exact
            />
            <Route
              path="/feedback-form-templates/:slug/"
              component={TemplateDetail}
              exact
            />

            <PrivateRoute
              path="/feedback-forms/"
              component={FeedbackForms}
              exact
            />
            <PrivateRoute
              path="/feedback-forms/templates/"
              component={FeedbackForms}
              exact
            />
            <PrivateRoute
              path="/feedback-forms/create/"
              component={FeedbackFormsDetails}
              exact
            />
            <PrivateRoute
              path="/feedback-forms/:formID/"
              component={FeedbackFormsDetails}
              exact
            />

            <PrivateRoute path="/dashboard/" component={Dashboard} exact />
            <PrivateRoute path="/employee/" component={Employee} exact />
            <PrivateRoute path="/report-page/" component={ReportPage} exact />
            <PrivateRoute
              path="/generate-report/:slug/"
              component={GenerateReport}
              exact
            />
            
            <PrivateRoute
              path="/report/detailed-report/"
              component={DetailedGenerateReport}
              exact
            />


            {/* Settings */}
            <PrivateRoute path="/settings" component={SettingPage} exact />
            <PrivateRoute
              path="/setting/form-setting/"
              component={FormSetting}
              exact
            />
            <PrivateRoute
              path="/setting/text-setting/"
              component={TextSetting}
              exact
            />
            <PrivateRoute
              path="/setting/image-setting/"
              component={ImageSetting}
              exact
            />
            <PrivateRoute
              path="/setting/device-setting/"
              component={DeviceSetting}
              exact
            />
            <PrivateRoute
              path="/setting/dashboard-setting/"
              component={DashboardSetting}
              exact
            />

            {/* Subscriptions */}
            <PrivateRoute
              path="/subscriptions"
              component={SubscriptionPage}
              exact
            />

            <PrivateRoute path="/customers/" component={Customers} exact />
            <PrivateRoute
              path="/customers/d/:id/"
              component={CustomerDetails}
              exact
            />
            <PrivateRoute
              path="/customers/upload/"
              component={UploadCustomers}
              exact
            />

            <PrivateRoute
              path="/balance-history/"
              component={BalanceHistory}
              exact
            />


            <PrivateRoute path="/feedbacks/" component={Feedbacks} exact />
            <PrivateRoute
              path="/feedbacks/:id/"
              component={FeedbackDetails}
              exact
            />

            <PrivateRoute path="/tickets/" component={TicketManagement} exact />
            <PrivateRoute
              path="/tickets/:id/"
              component={TicketDetails}
              exact
            />

            <Route component={NotFound} exact />
          </Switch>
        </Suspense>
      </Router>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadUser: () => dispatch(auth.loadUser()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
